(() => {
  function init(scope = document) {
    scope.querySelectorAll('[data-catalog-browser]').forEach(root => {
      if (root.classList.contains('catalog-ready')) return;
      const form = root.querySelector('.catalog-filter-form');
      const sidebar = root.querySelector('.catalog-sidebar');
      const panel = root.querySelector('.catalog-panel');
      const dialog = root.querySelector('.catalog-dialog');
      const toggle = root.querySelector('[data-catalog-toggle]');
      const label = toggle.querySelector('[data-toggle-label]');
      const sort = root.querySelector('select[name="sort_by"]');
      const mobile = matchMedia('(max-width:989px)');
      let sidebarHidden = false;
      const updateToggle = () => {
        label.textContent = mobile.matches ? 'Filters' : sidebarHidden ? 'Show filters' : 'Hide filters';
        toggle.setAttribute('aria-expanded', String(mobile.matches ? dialog.open : !sidebarHidden));
        toggle.setAttribute('aria-controls', mobile.matches ? dialog.id : sidebar.id);
      };
      const syncLayout = () => {
        if (dialog.open) dialog.close();
        if (mobile.matches) dialog.append(panel);
        else sidebar.append(panel);
        root.classList.toggle('catalog-is-hidden', !mobile.matches && sidebarHidden);
        updateToggle();
      };
      const navigate = href => {
        const url = new URL(href, location.origin);
        url.search = '';
        for (const [name, value] of new FormData(form)) {
          if (value !== '' && name !== 'page') url.searchParams.append(name, value);
        }
        url.hash = root.dataset.anchor || root.id;
        location.assign(url.href);
      };
      toggle.hidden = false;
      toggle.addEventListener('click', () => {
        if (mobile.matches) dialog.showModal();
        else {
          sidebarHidden = !sidebarHidden;
          root.classList.toggle('catalog-is-hidden', sidebarHidden);
        }
        updateToggle();
      });
      root.querySelector('[data-catalog-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
      dialog.addEventListener('close', () => { updateToggle(); toggle.focus(); });
      root.querySelectorAll('[data-facet-more]').forEach(button => {
        button.hidden = false;
        button.addEventListener('click', () => {
          const expanded = button.getAttribute('aria-expanded') !== 'true';
          button.setAttribute('aria-expanded', String(expanded));
          button.closest('.facet-group').toggleAttribute('data-expanded', expanded);
          button.textContent = expanded ? 'Show less' : button.dataset.moreLabel;
        });
      });
      root.querySelectorAll('[data-series-search]').forEach(search => {
        const group = search.closest('.facet-group');
        const input = search.querySelector('[data-series-query]');
        const clear = search.querySelector('[data-series-clear]');
        const status = search.querySelector('[data-series-status]');
        const more = group.querySelector('[data-facet-more]');
        const normalize = value => value.normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^\p{L}\p{N}]/gu, '');
        const options = [...group.querySelectorAll('.facet-option')].map(option => ({
          option, text: normalize(option.querySelector('a > span:nth-child(2)').textContent)
        }));
        const updateSearch = () => {
          const query = normalize(input.value);
          let matches = 0, selectedOutside = 0;
          group.toggleAttribute('data-searching', Boolean(query));
          options.forEach(({option, text}) => {
            const matchesQuery = !query || text.includes(query);
            const selected = option.classList.contains('is-selected');
            option.hidden = !matchesQuery && !selected;
            if (matchesQuery) matches++;
            else if (selected) selectedOutside++;
          });
          if (more) more.hidden = Boolean(query);
          clear.hidden = !input.value;
          status.hidden = !query;
          status.textContent = query ? (matches ? `${matches} matching series.` : 'No matching series.') + (selectedOutside ? ' Selected filters are shown below.' : '') : '';
        };
        input.addEventListener('input', updateSearch);
        input.addEventListener('keydown', event => {
          if (event.key === 'Enter') event.preventDefault();
          if (event.key === 'Escape' && input.value) {
            event.preventDefault(); event.stopPropagation(); input.value = ''; updateSearch();
          }
        });
        clear.addEventListener('click', () => { input.value = ''; updateSearch(); input.focus(); });
        search.hidden = false;
      });
      root.querySelectorAll('.facet-tags a,[data-active-tag] a').forEach(link => {
        link.removeAttribute('title');
        link.addEventListener('click', event => {
          if (event.button || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          navigate(link.href);
        });
      });
      form.addEventListener('submit', event => {
        event.preventDefault();
        if (form.reportValidity()) navigate(form.action);
      });
      form.addEventListener('change', event => {
        if (!mobile.matches && event.target.type === 'checkbox') form.requestSubmit();
      });
      sort.addEventListener('change', () => form.requestSubmit());
      mobile.addEventListener('change', syncLayout);
      root.closest('.shopify-section')?.addEventListener('shopify:section:unload', () => mobile.removeEventListener('change', syncLayout), { once: true });
      root.classList.add('catalog-ready');
      syncLayout();
    });
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
